import SPInspection from '@lib/spproject/SPInspection';
import { type Inspection } from '@lib/spproject/types';
import { handleApiResult } from '@store/error';
import { apiSlice } from './apiSlice';
import { type IInspection, type InspectionFields } from './inspectionEndpoints';

export const checklistApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getChecklists: builder.query<IInspection[], { projectId: string; include?: InspectionFields }>({
      query: ({ projectId, include }) =>
        `/v1/projects/${projectId}/checklists${include ? `?include=${include.join(',')}` : ''}`,
      providesTags: (result, _error, { projectId }) => [
        { type: 'Checklist', id: 'LIST' },
        ...(result?.map(({ info }) => ({ type: 'Checklist' as const, id: info.id })) || []),
        { type: 'Project', id: projectId },
      ],
      transformResponse: (checklists: IInspection[]) => checklists.map(checklist => {
        SPInspection.transformInspectionForCompatibility(checklist as unknown as Inspection.Inspection);
        return checklist;
      }),
      onQueryStarted: handleApiResult(),
    }),
  }),
});

export const {
  useGetChecklistsQuery,
  useLazyGetChecklistsQuery,
} = checklistApiSlice;
